<div *ngFor="let category of categories" class="category">
  <div class="category__header">
    <div class="title text_heading-6">{{ category.categoryName }}</div>
    <app-link class="link" (click)="selectCategory(category.categoryId)">
      {{ 'common.buttons.all' | translate }}
    </app-link>
  </div>

  <ng-container [ngSwitch]="productListMode">
    <lp-products-carousel
      *ngSwitchCase="'grid'"
      [products]="category.products"
      [showIsFavorite]="showIsFavorite"
    ></lp-products-carousel>

    <lp-products-list
      *ngSwitchDefault
      class="category__products-list"
      [products]="category.products"
      [productListMode]="productListMode"
      [showIsFavorite]="showIsFavorite"
    ></lp-products-list>
  </ng-container>
</div>
